// extracted by mini-css-extract-plugin
export default {"root":"IconButton_root__yiOJX","active":"IconButton_active__qB8At","rounded":"IconButton_rounded__A+8XT"};